<div class="ae-page">

  <!-- Header -->
  <div class="ae-header">
    <div class="ae-header__left">
      <div class="ae-header__icon"><mat-icon>cloud_download</mat-icon></div>
      <div>
        <h1 class="ae-header__title">Exportación contable</h1>
        <p class="ae-header__sub">Descarga los datos contables en formato Excel</p>
      </div>
    </div>
  </div>

  <!-- Diario contable -->
  <div class="ae-card">
    <div class="ae-card__head">
      <div class="ae-card__icon"><mat-icon>menu</mat-icon></div>
      <div>
        <h2 class="ae-card__title">Diario Contable</h2>
        <p class="ae-card__sub">Exporta los asientos del diario filtrados por rango de meses</p>
      </div>
    </div>

    <div class="ae-card__body">
      <mat-form-field appearance="outline" class="ae-field">
        <mat-label>Desde</mat-label>
        <mat-select [formControl]="monthFromExport">
          <mat-option *ngFor="let m of months; let i = index; trackBy: trackByIndex" [value]="i">{{ m }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="ae-field">
        <mat-label>Hasta</mat-label>
        <mat-select [formControl]="monthToExport">
          <mat-option *ngFor="let m of months; let i = index; trackBy: trackByIndex" [value]="i">{{ m }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-slide-toggle [formControl]="globalExport" class="ae-toggle">
        Todas las actividades
      </mat-slide-toggle>
    </div>

    <div class="ae-card__actions">
      <button mat-flat-button class="ae-btn-primary" (click)="exportDiary()" [disabled]="isLoadingDiary">
        <mat-icon>file_download</mat-icon>
        {{ isLoadingDiary ? 'Exportando…' : 'Descargar Excel' }}
      </button>
      <span class="ae-loading-dots" *ngIf="isLoadingDiary">
        <span></span><span></span><span></span>
      </span>
    </div>
  </div>

</div>
